<template>
  <picker-field :label="label" :value="value" :is-focus="isFocus" :isNeedInput="isNeedInput" title="选择工单号" @onchange="onchange" ref="picker" @open="onSearch">
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="ma_code,ma_prodcode"
        placeholder="输入单据编号、产品名称进行查找"
        ref="searchBar"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>
            {{item.ma_code}}
            <span class="list-item-status">{{item.ma_kind}}</span>
          </p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ma_prdetail}}</p>
          <p class="smallSize" v-if="item.ma_prorispeccode">型号-{{item.ma_prorispeccode}}</p>
        </div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "工单号"
    },
    value: String,
    isNeedInput: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isFocus: false,
      listUrl: "/api/make/make/list",
      defaultCondition: [
        {
          field: "ma_statuscode",
          operation: "!=",
          value: "UNAUDITED"
        },
        {
          field: "ma_tasktype",
          operation: "=",
          value: "MAKE"
        },
      ]
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.ve_name);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this
      me.$emit("onchange", value);
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    },
    
  }
};
</script>

<style scoped>
.smallSize{
  font-size: 12px;
  color: #999;
}
</style>